import React from 'react';
import { fetchSmallWebsiteLogo } from '../../../components/design';
import { Server } from '../../constants/server';
import { formatPrice } from '../../utilities/intl';
import {  GlobalOutlined, MailOutlined, MobileOutlined } from '@ant-design/icons';
import { textToClassName } from '../../utilities/common';
import { getOrderStatusName } from '../steps';

const source = {
  display: 'flex',
  flexFlow: 'row',
  gap: '0.5rem',
  justifyContent: 'flex-start'
}

function getSourceIcon(status_id = 'eamil', ItemId) {
    if (status_id == 'email') {
        return <div style={source}>
            <strong>{ItemId}</strong>
            <MailOutlined style={{ fontSize: '20px', color: '#EAB935' }} />
        </div>

    }
    if (status_id == 'phone') {
        return <div style={source}>
            <strong>{ItemId}</strong>
            <MobileOutlined style={{ fontSize: '20px', color: '#4178D1' }} />
        </div>
    }
    else {
        return <div style={source}>
            <strong>{ItemId}</strong>
            <GlobalOutlined style={{ fontSize: '20px', color: '#6E589D' }} />
        </div>

    }
}

export const OrderColumns = [
    {
        title: 'Order Id',
        dataIndex: 'id',
        sorter: true,
        fixed: 'left',
        render: (id, data) => getSourceIcon(data.project?.source?.id, id)
    },
    {
        title: 'Item',
        dataIndex: 'product',
        sorter: true,
        fixed: 'left',
        render: (product) => product.name
    },
    {
        title: 'Company',
        dataIndex: ['project', 'customer'],
        render: (customer) => {
            return fetchSmallWebsiteLogo(customer.website, customer.company)
        }
        //sorter: true,
    },
    {
        title: 'Account Manager',
        dataIndex: ['project', 'sales_manager'],
        render: (user) => user?.name
        //sorter: true,
    },
    {
        title: 'Order Status',
        dataIndex: "order_status",
        render: (order_status) => {
            const statusName = getOrderStatusName(order_status) ?? '';
            return <div className={`status-tag status-tag--${textToClassName(statusName)}`}>{statusName}</div>;
    },
        //sorter: true,
    },
    {
        title: 'Payment Status',
        dataIndex: ['project', 'payment_term'],
        //sorter: true,
        render: (term) => term?.name,
    },
    {
        title: 'Total Price',
        dataIndex: 'approved_vendor_price',
        render: (approved_vendor_price) => formatPrice(approved_vendor_price?.total_price, 'EUR')
        //sorter: true,
    },
    {
        title: 'Country',
        dataIndex: ['project', 'customer'],
        ///sorter: true,
        render: (customer) => {
            return <img src={`${Server.BaseUrl}/${customer?.country?.flag_url}`} alt={customer?.country?.name} title={customer?.country?.name} />
        }
    },
    // {
    //     title: 'Language',
    //     dataIndex: 'language',
    //     //sorter: true,
    //     render: language => language.name
    // },
    {
        title: 'Order Manager',
        dataIndex: 'order_manager',
        //sorter: true,
        render: user => user?.name
    },
    // {
    //     title: 'Contact',
    //     dataIndex: 'contact',
    //     render: contact => contact?.email
    //     //sorter: true,
    // },

]